import { UseQueryResult, useQuery } from 'react-query';
import { ResponseError } from 'superagent';
import { Team } from '@cbinsights/adminservice/adminservice';
import { request } from 'client/modules/common/utils/request';

export const useGetAllTeams = (): UseQueryResult<Team[], ResponseError> =>
  useQuery(['adminservice/GetAllTeams'], () =>
    request({
      url: '/service/adminservice/GetAllTeams',
      body: {},
    }).then((res): Team[] => res.body.teams)
  );
